export default {"src":"/_next/static/media/radio-icon.1370c88e.svg","height":18,"width":18};